import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { ACCOUNT_LINK } from '~shared/constants/links.constants';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { AuthorizationStateType } from '~app/modules/authorization/constants/authorization.constant';
import { isSoftLoggedIn } from '~server/utils/auth.utils';


@Injectable({
  providedIn: 'root',
})
export class NotAuthGuard implements CanActivate {
  constructor (
    private router: Router,
    private authorizationIdamStateService: AuthorizationIdamStateService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {

    return this.authorizationIdamStateService.state$.pipe(
      filter(({ type }) => type !== AuthorizationStateType.Pending),
      map(({ type }) => type !== AuthorizationStateType.LoggedIn || isSoftLoggedIn() || this.router.parseUrl(ACCOUNT_LINK)),
    );
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
